export default {
      id: "career-maturity-usage",
      viewBox: "0 0 99 101",
      url: __webpack_public_path__ + "sprite.svg#career-maturity",
      toString: function () {
        return this.url;
      }
    }